import React from "react";
import classNames from "classnames";
import "./index.scss";

import { getVehicleTypeTooltip, VEHICLE_TYPE } from "../../../utils/enums";

import IconButton from "../IconButton";

const VehicleSelector = ({
    value,
    onSelect
}) => {
    const handleOnClick = vehicleType => {
        return new Promise(resolve=> {
            resolve();
            onSelect(value === VEHICLE_TYPE[vehicleType] ? null : VEHICLE_TYPE[vehicleType]);
        });
    }

    return (
        <div className={classNames("vehicleSelector")}>
            {Object.keys(VEHICLE_TYPE).map(vehicleType=> (
                <div key={`vehicleSelectorItem-${vehicleType}`} className={classNames("vehicleSelectorItem", { selected: value === VEHICLE_TYPE[vehicleType] })}
                    onClick={()=> onSelect(value === VEHICLE_TYPE[vehicleType] ? null : VEHICLE_TYPE[vehicleType])}
                >
                    <IconButton isIcon={true} 
                        iconName={vehicleType} 
                        tooltipText={getVehicleTypeTooltip(vehicleType)}
                        active={value === VEHICLE_TYPE[vehicleType]}
                        onClick={()=> handleOnClick(vehicleType)}
                    />
                </div>
            ))}
        </div>
    );
}

export default VehicleSelector;